import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Header from './components/Header'
import Boards from './components/Boards'
import Lists from './components/Lists';
import { getBoards, createBoard, deleteBoard } from './api'
const { REACT_APP_KEY, REACT_APP_TOKEN, REACT_APP_API } = process.env;

function App() {

  const [boards, setBoards] = useState([])

  useEffect(() => {

    const getAllBoards = async () => {
      const boards = await getBoards(REACT_APP_API, REACT_APP_KEY, REACT_APP_TOKEN)
      setBoards(boards);
    }
    getAllBoards();
  }, []);

  const addBoard = async (title) => {

    const board = await createBoard(title, REACT_APP_API, REACT_APP_KEY, REACT_APP_TOKEN)
    setBoards([...boards, board]);
  }

  const delBoard = async (boardId) => {

    await deleteBoard(boardId, REACT_APP_KEY, REACT_APP_TOKEN, REACT_APP_API)
    setBoards(boards.filter(board => board.id !== boardId))
  }

  return (
    <Router>
      <div className="App">
        <Header />
        <Route path='/' exact render={(props) => (
          <>
            {boards.length > 0 ? (
              <Boards
                boards={boards}
                onDelete={delBoard}
                onCreate={addBoard}
              />
            ) : (
              ''
            )}
          </>
        )} />
         <Route path='/b/:id/:name' component={Lists} />
      </div>
    </Router>
  );
}

export default App;
